import { put, call, takeEvery, all } from 'redux-saga/effects'

import {
  SET_AUTO_VERSIONING_VERSION,
  SET_AUTO_VERSIONING_BRANDS,
  AUTO_VERSIONING_UNCONFIRM,
  AUTO_VERSIONING_KICKOFF,
  FETCH_AUTO_VERSIONING_PROGRESS,
  AUTO_VERSIONING_RESET,
  AUTO_VERSIONING_CANCEL,
  AUTO_VERSIONING_ROLLBACK,
} from '../actions/types'

import {
  fetchProgress,
  setVersionSuccess,
  setVersionFailure,
  setBrandsSuccess,
  setBrandsFailure,
  unconfirmSuccess,
  unconfirmFailure,
  kickoffSuccess,
  kickoffFailure,
  fetchProgressSuccess,
  fetchProgressFailure,
  rollbackSuccess,
  rollbackFailure,
  cancelSuccess,
  cancelFailure,
  resetSuccess,
  resetFailure,
} from '../actions/autoVersioningActions'
import autoVersioningService from '../services/autoVersioningService'

function* handleSetVersion(action) {
  try {
    const { indexVersion, accessToken } = action.payload

    yield call(autoVersioningService.setVersion, accessToken, indexVersion)
    yield put(setVersionSuccess())
    yield put(fetchProgress(accessToken))
  } catch (err) {
    console.error(err, 'Error setting version for auto versioning')
    yield put(setVersionFailure(err))
  }
}

function* handleSetBrands(action) {
  try {
    const { brandsToIndex, accessToken } = action.payload
    yield call(autoVersioningService.setBrands, accessToken, brandsToIndex)
    yield put(setBrandsSuccess())
    yield put(fetchProgress(accessToken))
  } catch (err) {
    console.error(err, 'Error setting brands for auto versioning')
    yield put(setBrandsFailure(err))
  }
}

function* handleUnconfirm(action) {
  try {
    const { accessToken } = action.payload
    yield call(autoVersioningService.unconfirm, accessToken)
    yield put(unconfirmSuccess())
    yield put(fetchProgress(accessToken))
  } catch (err) {
    console.error(err, 'Error unconfirming auto versioning')
    yield put(unconfirmFailure(err))
  }
}

function* handleKickoff(action) {
  try {
    const { accessToken } = action.payload
    yield call(autoVersioningService.kickoff, accessToken)
    yield put(kickoffSuccess())
    yield put(fetchProgress(accessToken))
  } catch (err) {
    console.error(err, 'Error kicking off auto versioning')
    yield put(kickoffFailure(err))
  }
}

function* handleFetchProgress(action) {
  try {
    const { accessToken } = action.payload
    const response = yield call(autoVersioningService.fetchProgress, accessToken)
    yield put(fetchProgressSuccess(response))
  } catch (err) {
    console.error(err, 'Error fetch auto versioning progress')
    yield put(fetchProgressFailure(err))
  }
}

function* handleReset(action) {
  try {
    const { accessToken } = action.payload
    yield call(autoVersioningService.reset, accessToken)
    yield put(resetSuccess())
    yield put(fetchProgress(accessToken))
  } catch (err) {
    console.error(err, 'Error resetting auto versioning')
    yield put(resetFailure(err))
  }
}

function* handleCancel(action) {
  try {
    const { accessToken } = action.payload
    yield call(autoVersioningService.cancel, accessToken)
    yield put(cancelSuccess())
    yield put(fetchProgress(accessToken))
  } catch (err) {
    console.error(err, 'Error cancelling auto versioning')
    yield put(cancelFailure(err))
  }
}

function* handleRollback(action) {
  try {
    const { accessToken } = action.payload
    yield call(autoVersioningService.rollback, accessToken)
    yield put(rollbackSuccess())
    yield put(fetchProgress(accessToken))
  } catch (err) {
    console.error(err, 'Error rolling back auto versioning')
    yield put(rollbackFailure(err))
  }
}

function* watchStatusSagas() {
  yield all([
    yield takeEvery(SET_AUTO_VERSIONING_VERSION, handleSetVersion),
    yield takeEvery(SET_AUTO_VERSIONING_BRANDS, handleSetBrands),
    yield takeEvery(AUTO_VERSIONING_UNCONFIRM, handleUnconfirm),
    yield takeEvery(AUTO_VERSIONING_KICKOFF, handleKickoff),
    yield takeEvery(FETCH_AUTO_VERSIONING_PROGRESS, handleFetchProgress),
    yield takeEvery(AUTO_VERSIONING_RESET, handleReset),
    yield takeEvery(AUTO_VERSIONING_CANCEL, handleCancel),
    yield takeEvery(AUTO_VERSIONING_ROLLBACK, handleRollback),
  ])
}

export default watchStatusSagas
